import React, { useEffect } from "react";
import "./App.css";
import HeroSection from "./components/HeroSection";
import IntroSection from "./components/IntroSection";
import ProductsOverview from "./components/ProductsOverview";
import ProductDetail from "./components/ProductDetail";
import StrongPoints from "./components/StrongPoints";
import FinalMessage from "./components/FinalMessage";
import Footer from "./components/Footer";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { THEME_COLORS } from "./constants/colors";

// eComicScreen+ images
import screenPlusPc from "./assets/manga_plus.webp";
import titlePlus from "./assets/title_plus.webp";
import mangaPlus1 from "./assets/manga_plus_1.webp";
import mangaPlus2 from "./assets/manga_plus_2.webp";
import mangaPlus3 from "./assets/manga_plus_3.webp";
import mangaPlus4 from "./assets/manga_plus_4.webp";
import mangaPlus5 from "./assets/manga_plus_5.webp";

// eComicSR images
import srPc from "./assets/manga_sr.webp";
import titleSr from "./assets/title_sr.webp";
import mangaSr1 from "./assets/manga_sr_1.webp";
import mangaSr2 from "./assets/manga_sr_2.webp";
import mangaSr3 from "./assets/manga_sr_3.webp";
import mangaSr4 from "./assets/manga_sr_4.webp";

// eComicScreen ReM images (暫定的にeComic-seriesの画像を使用)
import remPc from "./assets/manga_rem.webp";
import titleRem from "./assets/title_rem.webp";
import mangaRem1 from "./assets/manga_rem_1.webp";
import mangaRem2 from "./assets/manga_rem_2.webp";
import mangaRem3 from "./assets/manga_rem_3.webp";
import mangaRem4 from "./assets/manga_rem_4.webp";
import mangaRem5 from "./assets/manga_rem_5.webp";

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // スムーススクロールの設定
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener(
        "click",
        function (this: HTMLAnchorElement, e: Event) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute("href")!);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        },
      );
    });
  }, []);

  return (
    <div className="App">
      <HeroSection />
      <IntroSection />
      <ProductsOverview />
      <ProductDetail
        id="screen-plus"
        title="eComicScreen+™"
        titleImg={titlePlus}
        subtitle="大きな画像をキレイに作成することに特化"
        description="電子コミックで発生するモアレを効果的に抑制した画像を作成する技術。\nモアレに悩まされることなく、シャープでキレイな線やセリフを実現します。\n新刊電子コミックに最適。"
        sampleLink="https://www.kyodoprinting.co.jp/lp/ecomicscreenplus_demo/index.html"
        imagePosition="left"
        themeColor={THEME_COLORS.screenPlus}
        titleClass={"detail-title"}
        pcImage={screenPlusPc}
        mobileImages={[
          { src: mangaPlus1, width: 85 },
          { src: mangaPlus2, width: 75 },
          { src: mangaPlus3, width: 60 },
          mangaPlus4,
          { src: mangaPlus5, width: 90 },
        ]}
        showMoireLink={true}
      />
      <ProductDetail
        id="sr"
        title="eComicSR®"
        titleImg={titleSr}
        subtitle="小さな画像をキレイに拡大することに特化"
        description="これまで制作した電子コミックファイルを超解像変換する技術。\n電子コミックを再制作することなく線も色もキレイに高解像度化します。\n既刊電子コミックに最適。"
        sampleLink="https://www.kyodoprinting.co.jp/lp/ecomicsr_demo/index.html"
        imagePosition="right"
        themeColor={THEME_COLORS.sr}
        titleClass={"detail-title"}
        pcImage={srPc}
        mobileImages={[
          { src: mangaSr1, width: 80 },
          { src: mangaSr2, width: 85 },
          mangaSr3,
          mangaSr4,
        ]}
        showMoireLink={false}
      />
      <ProductDetail
        id="rem"
        title="eComicScreen ReM™"
        titleImg={titleRem}
        subtitle="スクリーントーンを高速に除去する"
        description="複雑なスクリーントーンやグラデーションも高精度に除去する技術。\nまんが画像をキレイな線画データに変換します。\nカラー化の前準備で必要なトーン除去を自動化。"
        sampleLink="https://www.kyodoprinting.co.jp/lp/ecomicscreenrem_demo/index.html"
        imagePosition="left"
        themeColor={THEME_COLORS.screenRem}
        titleClass={"detail-title"}
        pcImage={remPc}
        mobileImages={[
          { src: mangaRem1, width: 70 },
          { src: mangaRem2, width: 75 },
          { src: mangaRem3, width: 60 },
          mangaRem4,
        ]}
        showMoireLink={false}
      />
      {/* <StrongPoints /> */}
      <FinalMessage />
      <Footer />
    </div>
  );
}

export default App;
